// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/shipping/v1/legacy_portal_service.proto (package spwn.shipping.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { Message, proto3 } from "@bufbuild/protobuf";
import { LegacyPortalAddressInfo, LegacyPortalShippingStatus, LegacyPortalShippingStatusEntry } from "./legacy_portal_common_pb";
/**
 * fulfillment_firestore_idを指定して配送状況を取得
 *
 * @generated from message spwn.shipping.v1.LegacyPortalShippingServiceGetShippingStatusByFulfillmentFirestoreIdRequest
 */
export class LegacyPortalShippingServiceGetShippingStatusByFulfillmentFirestoreIdRequest extends Message {
    constructor(data) {
        super();
        /**
         * FulfillmentのFirestore ID
         *
         * @generated from field: string fulfillment_firestore_id = 1;
         */
        this.fulfillmentFirestoreId = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalShippingServiceGetShippingStatusByFulfillmentFirestoreIdRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalShippingServiceGetShippingStatusByFulfillmentFirestoreIdRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalShippingServiceGetShippingStatusByFulfillmentFirestoreIdRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LegacyPortalShippingServiceGetShippingStatusByFulfillmentFirestoreIdRequest, a, b);
    }
}
LegacyPortalShippingServiceGetShippingStatusByFulfillmentFirestoreIdRequest.runtime = proto3;
LegacyPortalShippingServiceGetShippingStatusByFulfillmentFirestoreIdRequest.typeName = "spwn.shipping.v1.LegacyPortalShippingServiceGetShippingStatusByFulfillmentFirestoreIdRequest";
LegacyPortalShippingServiceGetShippingStatusByFulfillmentFirestoreIdRequest.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "fulfillment_firestore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.shipping.v1.LegacyPortalShippingServiceGetShippingStatusByFulfillmentFirestoreIdResponse
 */
export class LegacyPortalShippingServiceGetShippingStatusByFulfillmentFirestoreIdResponse extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalShippingServiceGetShippingStatusByFulfillmentFirestoreIdResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalShippingServiceGetShippingStatusByFulfillmentFirestoreIdResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalShippingServiceGetShippingStatusByFulfillmentFirestoreIdResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LegacyPortalShippingServiceGetShippingStatusByFulfillmentFirestoreIdResponse, a, b);
    }
}
LegacyPortalShippingServiceGetShippingStatusByFulfillmentFirestoreIdResponse.runtime = proto3;
LegacyPortalShippingServiceGetShippingStatusByFulfillmentFirestoreIdResponse.typeName = "spwn.shipping.v1.LegacyPortalShippingServiceGetShippingStatusByFulfillmentFirestoreIdResponse";
LegacyPortalShippingServiceGetShippingStatusByFulfillmentFirestoreIdResponse.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "shipping_status", kind: "message", T: LegacyPortalShippingStatus },
    { no: 2, name: "shipping_unique_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
]);
/**
 * 複数の注文の配送状況をまとめて取得
 *
 * @generated from message spwn.shipping.v1.LegacyPortalShippingServiceGetAllShippingStatusesRequest
 */
export class LegacyPortalShippingServiceGetAllShippingStatusesRequest extends Message {
    constructor(data) {
        super();
        /**
         * SPWN(Firestore)由来の注文を指定する。fulfillmentのFirestore IDリスト
         *
         * @generated from field: repeated string fulfillment_firestore_ids = 1;
         */
        this.fulfillmentFirestoreIds = [];
        /**
         * Shopify(RDB)由来の注文を指定する。Shopify注文IDリスト
         *
         * @generated from field: repeated string shopify_order_ids = 2;
         */
        this.shopifyOrderIds = [];
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalShippingServiceGetAllShippingStatusesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalShippingServiceGetAllShippingStatusesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalShippingServiceGetAllShippingStatusesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LegacyPortalShippingServiceGetAllShippingStatusesRequest, a, b);
    }
}
LegacyPortalShippingServiceGetAllShippingStatusesRequest.runtime = proto3;
LegacyPortalShippingServiceGetAllShippingStatusesRequest.typeName = "spwn.shipping.v1.LegacyPortalShippingServiceGetAllShippingStatusesRequest";
LegacyPortalShippingServiceGetAllShippingStatusesRequest.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "fulfillment_firestore_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "shopify_order_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
]);
/**
 * @generated from message spwn.shipping.v1.LegacyPortalShippingServiceGetAllShippingStatusesResponse
 */
export class LegacyPortalShippingServiceGetAllShippingStatusesResponse extends Message {
    constructor(data) {
        super();
        /**
         * 配送状況一覧。解決できなかったキーは含まれない
         *
         * @generated from field: repeated spwn.shipping.v1.LegacyPortalShippingStatusEntry shipping_status_entries = 1;
         */
        this.shippingStatusEntries = [];
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalShippingServiceGetAllShippingStatusesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalShippingServiceGetAllShippingStatusesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalShippingServiceGetAllShippingStatusesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LegacyPortalShippingServiceGetAllShippingStatusesResponse, a, b);
    }
}
LegacyPortalShippingServiceGetAllShippingStatusesResponse.runtime = proto3;
LegacyPortalShippingServiceGetAllShippingStatusesResponse.typeName = "spwn.shipping.v1.LegacyPortalShippingServiceGetAllShippingStatusesResponse";
LegacyPortalShippingServiceGetAllShippingStatusesResponse.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "shipping_status_entries", kind: "message", T: LegacyPortalShippingStatusEntry, repeated: true },
]);
/**
 * @generated from message spwn.shipping.v1.LegacyPortalShippingServiceGetLegacyPortalAddressInfoRequest
 */
export class LegacyPortalShippingServiceGetLegacyPortalAddressInfoRequest extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalShippingServiceGetLegacyPortalAddressInfoRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalShippingServiceGetLegacyPortalAddressInfoRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalShippingServiceGetLegacyPortalAddressInfoRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LegacyPortalShippingServiceGetLegacyPortalAddressInfoRequest, a, b);
    }
}
LegacyPortalShippingServiceGetLegacyPortalAddressInfoRequest.runtime = proto3;
LegacyPortalShippingServiceGetLegacyPortalAddressInfoRequest.typeName = "spwn.shipping.v1.LegacyPortalShippingServiceGetLegacyPortalAddressInfoRequest";
LegacyPortalShippingServiceGetLegacyPortalAddressInfoRequest.fields = proto3.util.newFieldList(() => []);
/**
 * @generated from message spwn.shipping.v1.LegacyPortalShippingServiceGetLegacyPortalAddressInfoResponse
 */
export class LegacyPortalShippingServiceGetLegacyPortalAddressInfoResponse extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalShippingServiceGetLegacyPortalAddressInfoResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalShippingServiceGetLegacyPortalAddressInfoResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalShippingServiceGetLegacyPortalAddressInfoResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LegacyPortalShippingServiceGetLegacyPortalAddressInfoResponse, a, b);
    }
}
LegacyPortalShippingServiceGetLegacyPortalAddressInfoResponse.runtime = proto3;
LegacyPortalShippingServiceGetLegacyPortalAddressInfoResponse.typeName = "spwn.shipping.v1.LegacyPortalShippingServiceGetLegacyPortalAddressInfoResponse";
LegacyPortalShippingServiceGetLegacyPortalAddressInfoResponse.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "legacy_portal_address_info", kind: "message", T: LegacyPortalAddressInfo },
]);
//# sourceMappingURL=legacy_portal_service_pb.js.map